import { render } from "./ClassListPage.vue?vue&type=template&id=0ccce88e"
import script from "./ClassListPage.vue?vue&type=script&lang=js"
export * from "./ClassListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__